import api from "@/api";
import BatterTableDataView from "@/components/BatterTableDataView";
export default {
  name: "StreetSettingView",
  components: {
    BatterTableDataView
  },
  data() {
    return {
      enableMap: {},
      createVisible: false,
      initQuery: {}
    };
  },
  methods: {
    enableChange(id, val) {
      this.enableMap[id] = val;
      api.updateStreetEnableState(id, val);
    },
    onFetchData(d) {
      for (let itm of d.list) {
        this.enableMap[itm.id] = itm.enable;
      }
    },
    createStreet(data) {
      api.createStreet(data).then(() => {
        this.createVisible = false;
        this.initQuery = {
          'fresh': new Date()
        };
      });
    }
  }
};